import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {publish} from '../../actions/general';
import {ReactComponent as AttentionIcon} from '../../resources/imgs/attention-icon.svg';
import {getStyle} from '../../utils/StyleUtils';

interface StateProps {
  version: any
}

interface DispatchProps {
  publish: () => void,
}

interface OwnProps {
  cancel: () => void,
}

type Props = StateProps & DispatchProps & OwnProps;

const PublishFeedDialog = ({publish, version, cancel}: Props) => {
  const renderBody = () => {
    return <div className={'dialog-publish-body'}>
      <AttentionIcon/>
      <div className={'reels-attention-text'} style={{marginTop: '12px'}}>
                Are you sure ?
      </div>
      <div className={'reels-attention-description-text'} style={{marginTop: '25px'}}>
                Are you sure you want to publish version <b>{version ? version.id + 1 : 1}?</b>
      </div>
    </div>;
  };

  const renderFooter = () => {
    return <div className={'dialog-publish-footer'}>
      <button className={'reels-second-btn'} onClick={()=>{
        cancel();
      }}>
                Cancel
      </button>

      <button className={'save-btn'} style={{
        marginLeft: '25px',
      }}
      onClick={()=>{
        cancel();
        publish();
      }}
      >
                Yes, publish it!
      </button>
    </div>;
  };

  return <div className={getStyle('dialog-container')}>
    {renderBody()}
    {renderFooter()}
  </div>;
};

const mapStateToProps = (state: any) => ({
  version: state.appState.version,
});

const mapDispatchToProps = (dispatch: any) => ({
  publish: bindActionCreators(publish, dispatch),
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(PublishFeedDialog);

